import { useEffect, useState } from 'react'

export default function useTrainHandler(data: any, betId: string, bet: any) {
  const [lastResult, setlastResult] = useState<string>('')
  const [lastProfit, setlastProfit] = useState<number>(0)
  const [lastId, setlastId] = useState<string>('')
  const [showTrain, setshowTrain] = useState<boolean>(false)
  const [anim, setanim] = useState<boolean>(false)
  const [trainInfo, setTrain] = useState<any>([])

  // const handleHistory = (data: any) => {
  //   if (data[data.length - 1].bet_info.bet_id !== lastId) {
  //     const last = data.length - 1
  //     trainInfo.push({
  //       betId: data[last].bet_info.bet_id,
  //       roundId: data[last].round_id,
  //       result: data[last].bet_info.rolled,
  //       profit: data[last].bet_info.win - Number(data[last].bet_info.bet),
  //       up: Number(data[last].bet_info.over_or_under),
  //     })
  //     setlastResult(trainInfo[trainInfo.length - 1].result)
  //     setlastProfit(trainInfo[trainInfo.length - 1].profit)
  //     setlastId(trainInfo[trainInfo.length - 1].betId)
  //   }
  // }

  const handleHistory = (data: any) => {
    if (data.bet_id !== lastId) {
      const newCoef = {
        betId: data.bet_id,
        roundId: data.round_id,
        result: data.rolled,
        profit: data.win - Number(data.bet),
        up: Number(data.over_or_under),
      }
      if (trainInfo.length === 6) {
        setTrain((prevCoefs: any) => [...prevCoefs.slice(0, 6), newCoef])
      } else {
        setTrain((prevCoefs: any) => [...prevCoefs, newCoef])
      }
      if (trainInfo.length) {
        setlastResult(trainInfo[trainInfo.length - 1].result)
        setlastProfit(trainInfo[trainInfo.length - 1].profit)
        setlastId(trainInfo[trainInfo.length - 1].betId)
      }
    }
  }

  // useEffect(() => {
  //   // handleHistory()
  //   if (trainInfo.length > 7) {
  //     trainInfo.shift()
  //   }
  // }, [data[0]])

  useEffect(() => {
    if (data.length !== 0 && !bet.bet_id) {
      const coefs = data
        .map((el: any) => ({
          betId: el.bet_info.bet_id,
          roundId: el.round_id,
          result: el.bet_info.rolled,
          profit: el.bet_info.win - Number(el.bet_info.bet),
          up: Number(el.bet_info.over_or_under),
        }))
        .slice(0, 6).reverse()

      setTrain(coefs)
    }
  }, [data, bet])

  useEffect(() => {
    betId && handleHistory(bet)
    if (betId !== '0') {
      setanim(true)
      setTimeout(() => {
        setanim(false)
      }, 500)
    }
  }, [betId])


  useEffect(() => {
    trainInfo.length > 0 && setshowTrain(true)
  }, [trainInfo.length])

  return [lastProfit, lastResult, lastId, trainInfo, anim, showTrain]
}
